import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Alert, Button } from 'react-bootstrap';
import clienteAxios from '../../../../config/axios';

import { ICON_RESERVE, ICON_UNRESERVE, ICON_BAN, ICON_FINALIZE, ICON_PREV, ICON_RESULT, ICON_EDIT, ICON_CANCEL, ICON_APROVE, ICON_PRIORITY } from '../../../extras/icons';
import { SOLICITUD, RECONVERTIDA, REPROGRAMADA, CONTINUIDAD, AGENDADA, EFECTIVA, SUSPENDIDA } from '../../../../data/audienceStates';
import Swal from 'sweetalert2';
import { SuccessMessage, WaitingMessage, ErrorMessage } from '../../../extras/toastMessages';
import { C_GREEN, C_RED, C_BLACK, C_YELLOW } from '../../../extras/colors';
import { MSG_APPROVE_SUCCESS, MSG_REJECT_SUCCESS } from '../../../../constants/messages';

import RejectForm from './forms/RejectForm';
import CancelForm from './forms/CancelForm';
import ResultsForm from './forms/ResultsForm';
import RollBackForm from './forms/RollBackForm';
//Axios
import { useDispatch, useSelector } from 'react-redux'
import { approveAudiencesAction, reserveAudiencesAction } from '../../../../actions/audiencesActions';
import AuthoritiesService from '../../../../services/AuthoritiesService';
import { AUDIENCIAS_CANCELAR, AUDIENCIAS_RESERVAR, AUDIENCIAS_REABRIR, RESULTADOS_CREAR, SOLICITUDES_APROBAR, SOLICITUDES_RECHAZAR } from '../../../../data/objects';
//Función principal
const ActionsList = props => {
		//Tomo el history
		const history = useHistory();
		//Inicializo el dispatch
		const dispatch = useDispatch();
		//Traigo el store
		const authorities = useSelector(state => state.auth.authorities);
		//Tomo los props
		const { audience } = props;
		//Inicializo el state
		const [showReject, setShowReject] = useState(false);
		const [showCancel, setShowCancel] = useState(false);
		const [showFinalize, setShowFinalize] = useState(false);
		const [showRollBack, setShowRollBack] = useState(false);
		//Función para Aprobar
		const handleAprove = () => {
				Swal.fire({
						title: 'Aprobar Solicitud',
						text: 'Está por aprobar la solicitud de Audiencia',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: C_GREEN,
						confirmButtonText: 'Si, Aprobar'
				}).then(async (result) => {
						if(result.value){
								//Llamo al dispatch
								dispatch( approveAudiencesAction(audience) );
						}
				})
		}
		//Función para Rechazar
		const handleReject = () => {
				Swal.fire({
						title: 'Rechazar Solicitud',
						text: 'La operación de rechazo de solicitud no podrá revertirse',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: C_RED,
						confirmButtonText: 'Si, Rechazar'
				}).then((result) => {
						if(result.value){
								setTimeout(() => {
										handleOpenReject();
								}, 300);
						}
				})
		}

		//Función para abrir rechazo
		const handleOpenReject = () => {
				setShowReject(true);
		}

		//Función para cerrar rechazo
		const handleCloseReject = () => {
				setShowReject(false);
		}

		//Función para abrir cancel
		const handleOpenCancel = () => {
				setShowCancel(true);
		}

		//Función para cerrar cancel
		const handleCloseCancel = () => {
				setShowCancel(false);
		}

		//Función para Cancelar
		const handleCancel = () => {
				Swal.fire({
						title: 'Cancelar Audiencia',
						text: 'La operación de cancelación no podrá revertirse',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: C_RED,
						confirmButtonText: 'Si, Cancelar'
				}).then((result) => {
						if(result.value){
								setTimeout(() => {
										handleOpenCancel();
								}, 300);
						}
				})
		}
		//Función para Reservar
		const handleReserve = () => {
				Swal.fire({
						title: 'Reservar Audiencia',
						text: 'El públicO no podrá visualizar las actas ni los videos',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: C_BLACK,
						confirmButtonText: 'Si, Reservar'
				}).then((result) => {
						if(result.value){
								//Llamo al dispatch
								dispatch( reserveAudiencesAction(audience, 1) );
						}
				})
		}
		//Función para Finalizar
		const handleFinalize = () => {
				Swal.fire({
						title: 'Finalizar Audiencia',
						text: 'No podrá realizar modificaciones luego',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: C_GREEN,
						confirmButtonText: 'Si, Finalizar'
				}).then((result) => {
						if(result.value){
								setTimeout(() => {
										handleOpenFinalize();
								}, 300);
						}
				})
		}
		//Función para abrir finalize
		const handleOpenFinalize = () => {
				setShowFinalize(true);
		}

		//Función para cerrar cancel
		const handleCloseFinalize = () => {
				setShowFinalize(false);
		}

		//Función para qUITAR Reservar
		const handleUnreserve = () => {
				Swal.fire({
						title: 'Quitar Reserva de Audiencia',
						text: 'El público podrá visualizar las actas y los videos',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: C_BLACK,
						confirmButtonText: 'Si, Quitar'
				}).then((result) => {
						if(result.value){
								//Llamo al dispatch
								dispatch( reserveAudiencesAction(audience, 0) );
						}
				})
		}

		//Función para abrir rollback
		const handleOpenRollBack = () => {
			setShowRollBack(true);
		}

		//Función para cerrar rollback
		const handleCloseRollBack = () => {
			setShowRollBack(false);
		}
		
		//Renderizo
		return (
				<div className="col-12">
						<div className="card shadow mb-4">
								<div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
										<h6 className="m-0 font-weight-bold text-primary">ACCIONES</h6>
								</div>
								<div className="card-body">
										<div className="row">
											{
												audience.estado.id === AGENDADA && audience.videosSae === 1 ? (
													<div className="col-12">
														<Alert variant="warning">
															<ICON_PRIORITY />&nbsp;
															Los videos de esta audiencia <b>ya fueron migrados al SAE</b> cuando se finalizó la audiencia por primera vez. Si desea realizar modificaciones sobre los mismos, <b>deberá hacerlo manualmente en el SAE</b>.
														</Alert>
													</div>
												) : null
											}
												{
														audience.estado.id === SOLICITUD ? (
																<React.Fragment>
																		{
																				authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_APROBAR) ? (
																						<div className="col-md-4 mb-2">
																								<Button variant="success" block onClick={handleAprove}>
																										<ICON_APROVE /> <strong>APROBAR SOLICITUD</strong>
																								</Button>
																						</div>
																				) : null
																		}

																		{
																				authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_RECHAZAR) ? (
																						<div className="col-md-4 mb-2">
																								<Button variant="danger" block onClick={handleReject}>
																										<ICON_CANCEL /> RECHAZAR SOLICITUD
																								</Button>

																								<RejectForm
																										show={showReject}
																										handleClose={handleCloseReject}
																										audience={audience}
																								/>
																						</div>
																				) : null
																		}
																</React.Fragment>
														) : null
												}
												{
														audience.estado.id >= AGENDADA && audience.estado.id <= SUSPENDIDA  ? (
																<React.Fragment>
																		<div className="col-md-3 mb-2">
																				{
																						authorities && AuthoritiesService.hasPermission(authorities, AUDIENCIAS_RESERVAR) ? (
																								audience.privada === 0 ? (
																										<Button variant="dark" block onClick={handleReserve}>
																												<ICON_RESERVE /> RESERVAR AUDIENCIA
																										</Button>
																								) : (
																										<Button variant="outline-dark" block onClick={handleUnreserve}>
																												<ICON_UNRESERVE /> QUITAR RESERVA
																										</Button>
																								)
																						) : null
																				}
																		</div>
																</React.Fragment>
														) : null
												}
												{
														audience.estado.id === EFECTIVA || audience.estado.id === RECONVERTIDA || audience.estado.id === REPROGRAMADA|| audience.estado.id === CONTINUIDAD || audience.estado.id === SUSPENDIDA  ? (
																<React.Fragment>
																		<div className="col-md-3 mb-2">
																				{
																						authorities && AuthoritiesService.hasPermission(authorities, AUDIENCIAS_REABRIR) ? (
																							<React.Fragment>
																								<Button variant="warning" block onClick={handleOpenRollBack}>
																										<ICON_PREV /> VOLVER A AGENDADA
																								</Button>

																								<RollBackForm 
																									show={showRollBack} 
																									handleClose={handleCloseRollBack}
																									audience={audience}
																								/>
																							</React.Fragment>
																						) : null
																				}
																		</div>
																</React.Fragment>
														) : null
												}
												{
														audience.estado.id === AGENDADA ? (
																<React.Fragment>
																	{
																		authorities && AuthoritiesService.hasPermission(authorities, RESULTADOS_CREAR) ? (
																			<div className="col-md-3 mb-2">
																				<Button variant="success" block onClick={handleFinalize}>
																					<ICON_FINALIZE /> FINALIZAR AUDIENCIA
																				</Button>

																				<ResultsForm
																					show={showFinalize}
																					handleClose={handleCloseFinalize}
																					audience={audience}
																				/>
																			</div>
																		) : null
																	}
																	
																	{
																		authorities && AuthoritiesService.hasPermission(authorities, AUDIENCIAS_CANCELAR) ? (
																			<div className="col-md-3 mb-2">
																				<Button variant="danger" block onClick={handleCancel}>
																					<ICON_BAN /> CANCELAR AUDIENCIA
																				</Button>

																				<CancelForm
																					show={showCancel}
																					handleClose={handleCloseCancel}
																					audience={audience}
																				/>
																			</div>
																		) : null
																	}
																</React.Fragment>
														) : null
												}
										</div>
								</div>
						</div>
				</div>
		);
};

export default ActionsList;